export enum ToastTypes {
  standard = 'standard',
  success = 'success',
  warning = 'warning',
  error = 'error',
  info = 'info',
  danger = 'danger',
}
